export default __webpack_public_path__ + "static/media/ISKO CLASS-9 EXAM PATTERN 2026-27.bc4d3636.pdf";